var _WINDOW_HEIGHT = 0;
var _WINDOW_WIDTH = 0;
var nowSeg = 7;
var nowCat = 0;
var log;

(function (window, $) {
  var Cls = {};
  //

  var nowCatArr = [0, 4, 5, 1, 4, 1, 2];
  var maxSeg = nowCatArr.length - 1;
  var _mainHeight = 0;

  var SegCtrl = {
    Seg1: Seg1,
    Seg2: Seg2,
    Seg3: Seg3,
    Seg4: Seg4,
    Seg5: Seg5,
    Seg6: Seg6,
  };

  var $dots_back = null;
  var $dots_front = null;
  var $ribbon = null;
  var $main = null;
  var $bgWrap = null;
  var $header = null;
  var $contentsWrap = null;

  var $bt_prev = null;
  var $bt_next = null;
  var $dots = null;
  var $navi = null;
  var $naviBts = null;
  var $bt_replay = null;
  var $bt_bottom = null;

  var header_total_h = 0;
  var header_h = 0;
  var gnavi_h = 0;
  var breadcrumb_h = 0;

  var b_init = false;

  var b_opening = false;

  Cls.init = function () {
    $dots_back = $("#dots_back");
    $dots_front = $("#dots_front");
    $ribbon = $("#ribbon");
    $main = $("#main");
    $header = $(".brand-Header");
    $contentsWrap = $(".brand-Wrapper");
    $bgWrap = $("#bgWrap");

    $bt_prev = $(".fixedArea .prev");
    $bt_next = $(".fixedArea .next");
    $dots = $(".fixedArea .dots li");

    $navi = $("#navi");
    $naviBts = $("#navi li");

    $bt_replay = $("#js-replay img");
    $bt_bottom = $("#seg6 .bt_bottom");

    header_h = $header.outerHeight(true);
    gnavi_h = 0;
    breadcrumb_h = 0;
    header_total_h = header_h + gnavi_h + breadcrumb_h - 20;

    Cls.getWindowSize();
    Cls.fixedViewSize();
    Cls.startOpening();
    Cls.checkMouseScroll();

    Cls.resizeHandler();

    $(window).resize(Cls.resizeHandler);
  };

  Cls.getWindowSize = function () {
    _WINDOW_HEIGHT = $(window).height();
    _WINDOW_WIDTH = $(window).width();
  };

  Cls.resizeHandler = function () {
    Cls.getWindowSize();

    var adj_y_op =
      (_WINDOW_HEIGHT - header_total_h - 600) / 2 + (header_h + gnavi_h);
    var adj_y = (_WINDOW_HEIGHT - header_total_h - 600) / 2;

    $("#seg0.mainBox")
      .stop(true, true)
      .animate({ top: adj_y + "px" });

    $(".mainBox:not(div#seg0)")
      .stop(true, true)
      .animate({ top: adj_y_op - 65 + "px" });
    $("#seg7.mainBox")
      .stop(true, true)
      .animate({ top: adj_y + 155 + "px" });
    $contentsWrap.css({ height: _WINDOW_HEIGHT + 70 });
    $bgWrap.css({ height: _WINDOW_HEIGHT + 70 });

    /** Modify - END */
  };

  Cls.fixedViewSize = function () {
    $contentsWrap.css({ height: _WINDOW_HEIGHT + 30 });
    $bgWrap.css({ height: _WINDOW_HEIGHT });

    _mainHeight = parseInt($("#seg1").css("margin-bottom")) * 7 + 600 * 8;
    $main.css({
      top: _mainHeight * -1 + _WINDOW_HEIGHT + "px",
      height: _mainHeight + "px",
    });
  };

  Cls.startOpening = function () {
    Seg7.init(Cls.mainStart);
    //forDebug
    // Cls.debugStart(6);
  };

  Cls.mainStart = function () {
    window.scrollTo(0, -1);
    nowSeg = 0;
    $('#seg7').stop().fadeOut(2500, 'easeInQuart');
    Cls.scrollAnimation(_mainHeight - _WINDOW_HEIGHT, 6000, "easeInOutQuart");

    setTimeout(function () {
      if (!b_opening) {
        Opening.init(Cls.nextMoveY);
        Cls.startNaviAnime();

        if (!b_init) {
          Cls.addClickEventUi();
          Seg1.init();
          Seg2.init({
            prev_click_func: Cls.clickPrev_callback,
            next_click_func: Cls.clickNext_callback,
            dot_click_func: Cls.clickDots_callback,
          });
          Seg3.init();
          Seg4.init();
          Seg5.init();
          Seg6.init();

          b_init = false;
        }

        b_opening = true;
      }
    }, 4700);
  };

  Cls.checkMouseScroll = function () {
    $(window).bind('mousewheel',function(eo,delta){
      eo.preventDefault();
    });

    $(document).mousewheel(function (eo, delta, deltaX, deltaY) {
      if (deltaY > 0) {
        if (nowCat > 0) {
          if (nowSeg === 2) {
            if (Cls.isNotAnimated()) {
              Seg2.prev();
            }
          } else if (nowSeg === 6 && nowCat === 2) {
            if (Cls.isNotAnimated() && !Seg6.isAnimated) {
              Seg6.cat2reset();

              nowCat = 1;
            }
          } else if (nowSeg === 6 && nowCat === 1) {
            if (Cls.isNotAnimated() && !Seg6.isAnimated) {
              Seg6.cat0();
              nowCat = 0;
            }
          } else {
            if (Cls.isNotSegAnimated()) Cls.prevMoveX();
          }
        } else {
          if (Cls.isNotSegAnimated()) Cls.prevMoveY();
        }
      } else {
        if (nowCat >= nowCatArr[nowSeg]) {
          if (Cls.isNotSegAnimated()) {
            Cls.nextMoveY();
          }
        } else {
          if (nowSeg === 2) {
            if (Cls.isNotAnimated()) {
              Seg2.next();
            }
          } else if (nowSeg === 6 && nowCat === 0) {
            if (Cls.isNotAnimated() && !Seg6.isAnimated) {
              Seg6.cat1();
              nowCat = 1;
            }
          } else if (nowSeg === 6 && nowCat === 1) {
            if (Cls.isNotAnimated() && !Seg6.isAnimated) {
              Seg6.cat2();
              nowCat = 2;
            }
          } else {
            if (Cls.isNotSegAnimated()) Cls.nextMoveX();
          }
        }
      }
    });
  };

  Cls.nextMoveX = function () {
    if (Cls.isNotAnimated()) {
      if (nowCat < nowCatArr[nowSeg]) {
        Cls.clickNextButton();
      } else {
        Cls.nextMoveY();
      }
    }
  };

  Cls.prevMoveX = function () {
    if (Cls.isNotAnimated()) {
      if (nowCat > 0) {
        Cls.clickPrevButton();
      } else {
        Cls.prevMoveY();
      }
    }
  };

  Cls.nextMoveY = function () {
    if (nowSeg < maxSeg && Cls.isNotAnimated()) {
      nowSeg++;
      nowCat = 0;
      Cls.scrollAnimation(-2200, 2500);
    } else if (Cls.isNotAnimated()) {
      nowSeg = maxSeg;
      nowCat = nowCatArr[nowSeg];
      if (nowSeg !== 2) $("#seg" + nowSeg + " .catWrap").css({ left: "0%" });
    }
  };

  Cls.prevMoveY = function () {
    if (nowSeg > 0 && Cls.isNotAnimated()) {
      nowSeg--;
      nowCat = nowCatArr[nowSeg];

      if (nowSeg !== 2)
        $("#seg" + nowSeg + " .catWrap").css({
          left: nowCatArr[nowSeg] * -100 + "%",
        });
      Cls.scrollAnimation(2200, 2500);
    }
  };

  Cls.scrollAnimation = function (value, time, easing) {
    if (easing === undefined) {
      easing = "easeOutQuint";
    }

    /* Modify - START */

    if (nowSeg !== 0) {
      $bgWrap.animate(
        { height: _WINDOW_HEIGHT + (header_h + gnavi_h) + "px" },
        300,
        easing
      );
      $contentsWrap.animate(
        { height: _WINDOW_HEIGHT + (header_h + gnavi_h) + "px" },
        300,
        easing
      );
      $header.animate({ marginTop: -1 * header_h + "px" }, 300, easing);
    } else {
      $bgWrap.animate({ height: _WINDOW_HEIGHT + "px" }, 300, easing);
      setTimeout(function () {
        $contentsWrap.animate(
          { height: _WINDOW_HEIGHT + "px" },
          300,
          easing
        );
      }, 2000);
      $header.animate({ marginTop: 0 }, 300, easing);
    }
    /* Modify - END */

    var bgEase = easing;
    if (nowSeg === 7 || nowSeg === 0) bgEase = "easeOutBack";
    $ribbon
      .stop()
      .animate(
        { backgroundPosition: "center +=" + Math.round(value / 2) + "px" },
        time + 100,
        easing
      );

    $dots_front
      .stop()
      .animate(
        { backgroundPosition: "+=150 +=" + Math.round(value / 4) + "px" },
        time + 1200,
        bgEase
      );
    $dots_back
      .stop()
      .animate(
        { backgroundPosition: "-=150 +=" + Math.round(value / 6) + "px" },
        time + 2000,
        bgEase
      );
    setTimeout(function () {
      Cls.checkNextPrevBtn();
    }, 400);

    $main
      .stop()
      .animate({ top: "+=" + value + "px" }, time, easing, function () {
        if (!$navi.hasClass("opening")) {
          $naviBts.removeClass("active");
          $naviBts.eq(nowSeg).addClass("visited").addClass("active");
        }
      });
  };

  /**

     *
     */
  Cls.isNotAnimated = function () {
    return (
      !$main.is(":animated") &&
      !$("#seg" + nowSeg).is(":animated") &&
      !$("#seg" + nowSeg + " .catWrap").is(":animated")
    );
  };

  /**
   *
   */
  Cls.isNotSegAnimated = function () {
    return !(SegCtrl["Seg" + nowSeg] && SegCtrl["Seg" + nowSeg].isAnimated);
  };

  /*----------------------------------------------------------------------

    ----------------------------------------------------------------------*/
  Cls.startAnime = function () {
    if (nowSeg > 0 && nowSeg <= maxSeg)
      SegCtrl["Seg" + nowSeg]["cat" + nowCat]();
  };

  Cls.startNaviAnime = function () {
    var loaded_count = 0;

    $navi.addClass("opening").fadeIn(1000, function () {
      $naviBts.removeClass("active").removeClass("visited");
      $naviBts.each(function (idx) {
        var $item = $(this);
        var $dummy = $("<span />").addClass("dummy");

        $item.prepend($dummy);

        $dummy.animate({ width: "162px" }, 400, "easeOutQuint");

        if (idx > 0) {
          $item.animate({ width: "162px" }, 500, "easeOutQuint", function () {
            $dummy
              .delay(500 + idx * 120)
              .animate({ width: 0 }, 500, "easeOutQuint");
            $item
              .delay(500 + idx * 120)
              .animate({ width: "40px" }, 350, "easeOutQuint", function () {
                loadedHandler();
              });
          });
        }
      });
    });

    function loadedHandler() {
      loaded_count++;
      if (loaded_count >= $naviBts.length - 1) {
        $(".dummy", $naviBts).remove();

        $naviBts.eq(0).addClass("visited").addClass("active");

        $navi.removeClass("opening");

        Cls.addClickEventNavi();
      }
    }
  };

  /*----------------------------------------------------------------------
    UI
    ----------------------------------------------------------------------*/
  Cls.addClickEventUi = function () {
    $bt_next.click(Cls.clickNextButton);
    $bt_prev.click(Cls.clickPrevButton);

    $dots.click(Cls.clickDots);

    $bt_replay.click(Cls.clickReplay);
    $bt_bottom.click(function () {
      Seg6.cat1();
      nowCat = 1;
    });
  };

  Cls.addClickEventNavi = function () {
    $naviBts.click(Cls.clickNavi);
    $naviBts.hover(Cls.extendNavi, Cls.shrinkNavi);
  };

  Cls.clickNextButton = function () {
    if (Cls.isNotAnimated() && Cls.isNotSegAnimated()) {
      $("#seg" + nowSeg + " .catWrap")
        .stop()
        .animate({ left: "-=100%" }, 1500, "easeInOutQuint");
      nowCat++;
      Cls.checkNextPrevBtn();
    }
  };

  Cls.clickPrevButton = function () {
    if (Cls.isNotAnimated() && Cls.isNotSegAnimated()) {
      $("#seg" + nowSeg + " .catWrap")
        .stop()
        .animate({ left: "+=100%" }, 1500, "easeInOutQuint");
      nowCat--;
      Cls.checkNextPrevBtn();
    }
  };

  Cls.checkNextPrevBtn = function () {
    if (nowCat === 0) {
      $bt_prev.fadeOut();
      $bt_next.fadeIn();
    } else if (nowCat === nowCatArr[nowSeg]) {
      $bt_prev.fadeIn();
      $bt_next.fadeOut();
    } else {
      $bt_prev.fadeIn();
      $bt_next.fadeIn();
    }

    Cls.checkDots();

    Cls.startAnime();
  };

  Cls.checkDots = function () {
    $dots.each(function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
      }
      if ($(this).hasClass("dot" + nowCat)) {
        $(this).addClass("active");
      }
    });
  };

  Cls.clickDots = function () {
    if (Cls.isNotAnimated() && Cls.isNotSegAnimated()) {
      var no = Number($(this).attr("class").substr(3, 1));

      $("#seg" + nowSeg + " .catWrap")
        .stop()
        .animate({ left: "-" + no + "00%" }, 1500, "easeInOutQuint");
      nowCat = no;
      Cls.checkNextPrevBtn();
    }
  };

  Cls.clickPrev_callback = function () {
    nowCat--;
    Cls.checkNextPrevBtn();
  };

  Cls.clickNext_callback = function () {
    nowCat++;
    Cls.checkNextPrevBtn();
  };

  Cls.clickDots_callback = function (no) {
    nowCat = Number(no);
    Cls.checkNextPrevBtn();
  };

  Cls.clickReplay = function () {
    $("#Pager").hide();
    $navi.fadeOut(200);

    b_opening = false;

    $contentsWrap.animate({ marginTop: 0 }, 100, function () {
      $naviBts.eq(0).trigger("click");

      $navi.delay(2500).fadeIn(200);
    });
  };

  /*----------------------------------------------------------------------
    NAVI
    ----------------------------------------------------------------------*/
  Cls.clickNavi = function () {
    $(".brand-Nav").hide();
    if ($(this).hasClass("active")) return false;

    if (Cls.isNotAnimated()) {
      var no = Number($(this).attr("class").substr(8, 1));

      if (nowSeg === 6) Seg6.cat2reset();

      var prevSeg = nowSeg;
      nowSeg = no;
      nowCat = 0;

      if (nowSeg !== 2) $("#seg" + nowSeg + " .catWrap").css({ left: "0%" });
      Cls.scrollAnimation((prevSeg - nowSeg) * 2200, 2500);
      $naviBts.removeClass("active");
      $(this).addClass("visited").addClass("active");
    }
  };

  Cls.extendNavi = function () {
    if (!$(this).hasClass("navi_seg0")) {
      $(this).stop().animate({ width: "162px" }, 500, "easeOutQuint");
    }
  };

  Cls.shrinkNavi = function () {
    $(this).stop().animate({ width: "40px" }, 350, "easeOutQuint");
  };

  Cls.debugStart = function (seg) {
    if (seg > 0 && seg < 7) {
      nowSeg = Number(seg);

      Opening.init(Cls.nextMoveY);

      Cls.addClickEventUi();

      Cls.addClickEventNavi();

      Seg1.init();
      Seg2.init({
        prev_click_func: Cls.clickPrev_callback,
        next_click_func: Cls.clickNext_callback,
        dot_click_func: Cls.clickDots_callback,
      });
      Seg3.init();
      Seg4.init();
      Seg5.init();
      Seg6.init();

      b_init = false;
      b_opening = true;

      $("#seg7").hide();

      $navi.show();

      var offset_y = _mainHeight - _WINDOW_HEIGHT;
      var calc_pos_y = seg * -2200;

      Cls.scrollAnimation(offset_y + calc_pos_y, 100, "easeInOutQuart");
    } else if (seg === 0) {
      nowSeg = seg;
      Cls.mainStart();
    } else {
      Seg7.init(Cls.mainStart);
    }
  };

  window.common = Cls;

  $(window).ready(function () {
    common.init();
    window.addEventListener("beforeunload", () =>{
      window.scrollTo(0, -1);
    });
  });

  window.log = function () {
    if (typeof console === "undefined") return;

    var args = $.makeArray(arguments);
  }
})(window, $brand);
